<template>
  <div>
    <div class="details-box">
      <div class="details-box_tags">
        <Tag class="tag--text tag--public" v-for="i in artist.regions" :key="i" :value="i" />
      </div>
      <h2 class="details-box_title">{{ artist.name }}</h2>
      <p class="details-box_sub-title">{{ artist.yearsLocation }}</p>
      <div
        class="details-box_details collect-editor collect-editor--white"
        v-html="artist.biography"
      ></div>
    </div>
    <div class="details_video" v-if="artist.videos && artist.videos.url">
      <CustomVideo :src="artist.videos.url" />
      <p v-if="artist.videos.caption">{{ artist.videos.caption }}</p>
    </div>
  </div>
</template>

<script>
import Tag from "@/components/Tag.vue";
import CustomVideo from "@/components/CustomVideo.vue";

export default {
  components: {
    Tag,
    CustomVideo,
  },
  props: {
    artist: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.details-box {
  display: flex;
  flex-direction: column;
  width: 60%;
  @media screen and (max-width: $md) {
    width: 100%;
  }

  &_tags {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin: 0 0 15px;
    & > * {
      margin: 0;
    }
  }

  &_title {
    font-weight: 500;
    font-size: 4rem;
    line-height: 5rem;
    letter-spacing: -1.33333px;
    margin-bottom: 10px;
    @media screen and (max-width: $xs) {
      font-size: 3.5rem;
      line-height: 4.3rem;
    }
  }
  &_sub-title {
    font-weight: 500;
    font-size: 2.4rem;
    line-height: 2.9rem;
    letter-spacing: -0.8px;
    margin-bottom: 15px;
    @media screen and (max-width: $xs) {
    }
  }

  .button {
    margin-top: 2.2rem;
    @media screen and (max-width: $xs) {
      margin-top: 3.5rem;
    }
  }
}

.details {
  &_video {
    width: 100%;
    padding: 12rem 0 80px;
    @media screen and (max-width: $sm) {
      padding: 8rem 0 4rem;
    }
    @media screen and (max-width: $xs) {
      padding: 4rem 0;
    }
    p {
      font-size: 1.8rem;
      font-weight: 300;
      line-height: 1.66;
      color: $white;
      text-align: center;
      padding: 14px;
    }
  }
}
</style>

